import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

export const Box = ({
  align, height, width, padding, children
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      color: colors.softGray,
      height,
      width,
      lineHeight: 1.55,
      textAlign: align,
      fontSize: 'inherit',
      border: `1pt solid ${colors.softGray}`,
      borderRadius: 12,
      padding,
    }}
  >
    {children}
  </div>
)

Box.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  align: PropTypes.string,
  padding: PropTypes.number,
}

Box.defaultProps = {
  align: 'left',
  padding: 8,
  height: null,
}
